import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AppStore } from './core/services/app-store/app-store.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { ErrorsInterceptor } from './interceptors/errors.interceptor';
import { ScrollOnTopDirective } from './scroll-on-top.directive';



function initializeApp(store: AppStore) {
  return () => store.appLoaded().then();
}

@NgModule({
  declarations: [AppComponent, ScrollOnTopDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ComponentsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (store: AppStore) => initializeApp(store),
      multi: true,
      deps: [AppStore],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
